<template>
  <div class="my-pooq-content-body">
    <div class="mypooq-list"
         v-infinite-scroll="loadMore"
         :infinite-scroll-distance="200"
         :infinite-scroll-throttle-delay="200"
         v-if="device !== 'ios'">
      <div class="coin-table">
        <h4 class="mypooq-title">보유코인</h4>
        <table>
          <caption class="a11y-hidden">보유코인</caption>
          <colgroup>
            <col width="33.3333%">
            <col width="33.3333%">
            <col width="33.3333%">
          </colgroup>
          <thead>
          <tr>
            <th>총 코인</th>
            <th>충전 코인</th>
            <th>보너스 코인</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td>{{totalCoin | amount}}</td>
            <td>{{chargedCoin | amount}}</td>
            <td>{{bonusCoin | amount}}</td>
          </tr>
          </tbody>
        </table>
        <a href="#" class="coin-charge" @click.prevent="chargeCoinPopup">
          <span>코인 충전</span>
        </a>
      </div>
      <div class="select-box">
        <ul>
          <li :class="tabType === 'saving' ? 'on' : ''" @click.prevent="()=>changeTabType('saving')">적립 코인</li>
          <li :class="tabType === 'used' ? 'on' : ''" @click.prevent="()=>changeTabType('used')">소진 코인</li>
        </ul>
      </div>
      <my-pooq-empty-list v-if="showEmptyList"
                          :info-text="getEmptyText()"></my-pooq-empty-list>
      <ul class="coin-coupon-list">
        <li v-for="(coinInfo, index) in coinList" :key="tabType+'_'+index"
            :class="tabType === 'used' && expire(coinInfo) === 'y' ? 'expire' : ''">
          <span class="badge-group">
            <template v-if="autopayment(coinInfo) === 'true'">
               <span v-if="autopaymentStatus(coinInfo) === 'y'" class="badge ui">자동결제 이용중</span>
               <span v-if="autopaymentStatus(coinInfo) === 'n'" class="badge ui positive">해지신청 완료</span>
            </template>
            <template v-if="autopayment(coinInfo) === 'false'">
              <span class="badge ui negative">자동결제 비대상</span>
            </template>
          </span>
          <span class="coin-coupon-info">
            <span class="coin-coupon-info-detail">
              <span class="coin-coupon-title">{{title(coinInfo)}}</span>
                <template v-if="tabType === 'saving'">
                  <span class="release-date" v-if="startDateTime(coinInfo) !== ''">
                    <span>충전</span>
                    <i class="icon-dotted"></i>
                    <span>{{startDateTime(coinInfo)}}</span>
                  </span>
                  <span class="end-date" v-if="endDateTime(coinInfo)">
                    <span>만료</span>
                    <i class="icon-dotted"></i>
                    <span>{{endDateTime(coinInfo)}}</span>
                  </span>
                  <span class="remain-coin" v-if="remainCoin(coinInfo) !== ''">
                    <span>잔여</span>
                    <i class="icon-dotted"></i>
                    <span>{{remainCoin(coinInfo) | amount}}</span>
                  </span>
                  <span class="remain-coin">
                    <span>결제수단</span>
                    <i class="icon-dotted"></i>
                    <span>{{paymentMethod(coinInfo)}}</span>
                  </span>
                  <span class="reason" v-if="description(coinInfo) !== ''">
                    <span>지급 사유</span>
                    <i class="icon-dotted"></i>
                    <span>{{description(coinInfo)}}</span>
                  </span>
                </template>
                <template v-else-if="tabType === 'used'">
                  <span class="end-date" v-if="expire(coinInfo)==='y'">
                    <span>만료</span>
                    <i class="icon-dotted"></i>
                    <span>{{dateTime(coinInfo)}}</span>
                  </span>
                  <span class="end-date" v-else>
                    <span>사용</span>
                    <i class="icon-dotted"></i>
                    <span>{{dateTime(coinInfo)}}</span>
                  </span>
                </template>
              </span>
              <span class="total-coin">
                <CoinIcon/>
                  <span>
                    {{chargeCoin(coinInfo) | amount}}
                  </span>
              </span>
            </span>
          <span class="voucher-change" v-if="autopayment(coinInfo) === 'true'">
            <template v-if="isRequesting">
              <span class="voucher-cancel">처리중</span>
            </template>
            <template v-else>
              <span v-if="autopaymentStatus(coinInfo) === 'y'" class="voucher-cancel" @click.prevent="cancelCoinSubscription(coinInfo.paymentid)">자동결제 해지</span>
              <span v-if="autopaymentStatus(coinInfo) === 'n'" class="voucher-cancel" @click.prevent="revokeCoinSubscription(coinInfo.paymentid)">해지 취소</span>
            </template>
            <!--
            *2차 2월 중 반영 예정
            <span class="method-change">결제수단 변경</span>
            -->
          </span>
        </li>
      </ul>
    </div>
    <div class="mypooq-list" v-if="device === 'ios'">
      <my-pooq-empty-list info-text="코인 쿠폰 등록과 사용은<br>웨이브 홈페이지에서 이용 가능합니다."></my-pooq-empty-list>
    </div>
  </div>
</template>

<script>
import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
import CoinIcon from '@/assets/svg/common/tag-coin-p.svg'
import { MyPooqService } from '@/common/api/api.service'
import { amount } from '@/common/filters'
import { infiniteScroll } from '@/common/directives'
import { get } from 'lodash'
import utils from '@/common/util/utils'
import {
  MSG_MYPOOQ_CONFIRM_COIN_REVOKE_SUBSCRIBE,
  MSG_MYPOOQ_CONFIRM_COIN_UNSUBSCRIBE, PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE,
  PAYMENT_GATE_TYPE_ONE_STORE
} from '@/common/constant'
import { DEVICE_TYPE_ANDROID } from '@/common/devicetype.const'

const TAB_TYPE_SAVING = 'saving'
const CANCEL_COIN_SUBSCRIPTION = '0'
const REVOKE_COIN_SUBSCRIPTION = '1'

export default {
  name: 'Coin',
  components: {
    CoinIcon,
    MyPooqEmptyList
  },
  directives: {
    infiniteScroll
  },
  filters: {
    amount
  },
  data () {
    return {
      userCoinInfo: {},
      showEmptyList: false,
      tabType: 'saving',
      offset: 0,
      limit: 20,
      endOfList: false,
      coinList: [],
      isLoading: false,
      isRequesting: false,
      device: utils.cookies.getDevice(),
      autopaymentstatus: ''
    }
  },
  computed: {
    totalCoin () {
      return get(this.userCoinInfo, 'totalcoin', 0)
    },
    chargedCoin () {
      return get(this.userCoinInfo, 'chargedcoin', 0)
    },
    bonusCoin () {
      return get(this.userCoinInfo, 'bonuscoin', 0)
    }
  },
  methods: {
    resetData () {
      this.coinList = []
      this.showEmptyList = false
      this.endOfList = false
      this.offset = 0
      this.$nextTick(() => {
        this.setData()
      })
    },
    getEmptyText () {
      return `${this.tabType === TAB_TYPE_SAVING ? '적립' : '소진된'} 코인이 없어요.`
    },
    changeTabType (type) {
      this.tabType = type
    },
    changeCoinSubscription (paymentid, subscriptionStatus) {
      return MyPooqService.passPromotionCancel({ productType: 'coin', keyId: paymentid, status: subscriptionStatus })
    },
    cancelCoinSubscription (paymentid) {
      utils.asyncConfirm(MSG_MYPOOQ_CONFIRM_COIN_UNSUBSCRIBE).then((hasConfirm) => {
        if (hasConfirm) {
          this.isRequesting = true
          this.changeCoinSubscription(paymentid, CANCEL_COIN_SUBSCRIPTION).then(() => {
            setTimeout(() => {
              this.resetData()
              this.isRequesting = false
            }, 2000)
          })
        }
      })
    },
    revokeCoinSubscription (paymentid) {
      utils.asyncConfirm(MSG_MYPOOQ_CONFIRM_COIN_REVOKE_SUBSCRIBE).then((hasConfirm) => {
        if (hasConfirm) {
          this.isRequesting = true
          this.changeCoinSubscription(paymentid, REVOKE_COIN_SUBSCRIPTION).then(() => {
            setTimeout(() => {
              this.resetData()
              this.isRequesting = false
            }, 2000)
          })
        }
      })
    },
    chargeCoinPopup () {
      let locationOrigin = window.location.origin
      if (!locationOrigin) {
        locationOrigin = window.location.protocol + '//' + window.location.hostname
      }
      if (utils.cookies.getDevice() === DEVICE_TYPE_ANDROID) {
        try {
          const url = encodeURIComponent(window.location.origin +
              '/callback.html?action=ClosePopupAndReload')
          let pgName = utils.getPgName()
          if (pgName === PAYMENT_GATE_TYPE_GOOGLE_IN_APP_PURCHASE) {
            window.Android.openChargeCoinWebview(url, pgName)
          } else if (pgName === PAYMENT_GATE_TYPE_ONE_STORE) {
            window.Android.clickOneStoreChargeCoin(url, pgName)
          } else {
            window.Android.clickChargeCoin(url)
          }
        } catch (err) {
          console.log(err)
        }
      } else {
        utils.common.showCoinPopup(false, locationOrigin + '/callback.html?action=ClosePopupAndReload')
      }
    },
    loadMore () {
      if (this.endOfList) return
      this.setData()
    },
    setData () {
      if (this.isLoading) return
      this.isLoading = true
      const api = this.tabType === TAB_TYPE_SAVING ? MyPooqService.getMyCoinListCharged : MyPooqService.getMyCoinListExpired
      const params = { offset: this.offset, limit: this.limit, orderby: 'new' }
      api(params).then(({ data }) => {
        let resList = get(data, 'list', [])
        this.endOfList = resList.length === 0
        this.showEmptyList = this.coinList.length === 0 && resList.length === 0
        this.offset += this.limit
        this.coinList = this.coinList.concat(resList)
        this.isLoading = false
      })
    },
    paymentMethod (coin) {
      return get(coin, 'paymentmethod', '') === '' ? '-' : get(coin, 'paymentmethod', '')
    },
    expire (coin) {
      return get(coin, 'expire', '')
    },
    autopaymentStatus (coin) {
      return get(coin, 'autopaymentstatus', '')
    },
    autopayment (coin) {
      return get(coin, 'autopayment', 'false') === '' ? 'false' : get(coin, 'autopayment', 'false')
    },
    title (coin) {
      return get(coin, 'title', '')
    },
    startDateTime (coin) {
      return get(coin, 'startdatetime', '')
    },
    endDateTime (coin) {
      return get(coin, 'enddatetime', '')
    },
    remainCoin (coin) {
      return get(coin, 'remaincoin', '')
    },
    description (coin) {
      return get(coin, 'description', '')
    },
    dateTime (coin) {
      return get(coin, 'datetime', '')
    },
    chargeCoin (coin) {
      return get(coin, 'chargecoin', 0)
    }
  },
  created () {
    MyPooqService.getMyCoinSummary().then(({ data }) => {
      this.userCoinInfo = data
    })
  },
  watch: {
    tabType () {
      this.resetData()
    }
  }
}
</script>

<style scoped>
.mypooq-list{
  height: auto;
}
</style>
